// Generated by spriteMerger.js
import { ComponentProps } from 'react';
import Icon from '../Icon';
import editor from './editor.svg';

interface EditorIconProps extends Omit<ComponentProps<typeof Icon>, 'link'> {
  name: EditorNames;
}

export function EditorIcon({ name, ...props }: EditorIconProps) {
  return <Icon {...props} link={editor} name={name} />
}

type EditorNames =
  | 'add_chart'
  | 'add_comment'
  | 'align_horizontal_center'
  | 'align_horizontal_left'
  | 'align_horizontal_right'
  | 'align_vertical_bottom'
  | 'align_vertical_center'
  | 'align_vertical_top'
  | 'area_chart'
  | 'attach_file'
  | 'attach_money'
  | 'auto_graph'
  | 'bar_chart'
  | 'border_all'
  | 'border_bottom'
  | 'border_clear'
  | 'border_color'
  | 'border_horizontal'
  | 'border_inner'
  | 'border_left'
  | 'border_outer'
  | 'border_right'
  | 'border_style'
  | 'border_top'
  | 'border_vertical'
  | 'bubble_chart'
  | 'candlestick_chart'
  | 'checklist_rtl'
  | 'checklist'
  | 'data_array'
  | 'data_object'
  | 'drag_handle'
  | 'draw'
  | 'edit_note'
  | 'format_align_center'
  | 'format_align_justify'
  | 'format_align_left'
  | 'format_align_right'
  | 'format_bold'
  | 'format_clear'
  | 'format_color_fill'
  | 'format_color_reset'
  | 'format_color_text'
  | 'format_indent_decrease'
  | 'format_indent_increase'
  | 'format_italic'
  | 'format_line_spacing'
  | 'format_list_bulleted'
  | 'format_list_numbered_rtl'
  | 'format_list_numbered'
  | 'format_paint'
  | 'format_quote'
  | 'format_shapes'
  | 'format_size'
  | 'format_strikethrough'
  | 'format_textdirection_l_to_r'
  | 'format_textdirection_r_to_l'
  | 'format_underlined'
  | 'functions'
  | 'height'
  | 'hexagon'
  | 'highlight'
  | 'horizontal_distribute'
  | 'horizontal_rule'
  | 'insert_chart_outlined'
  | 'insert_chart'
  | 'insert_comment'
  | 'insert_drive_file'
  | 'insert_emoticon'
  | 'insert_invitation'
  | 'insert_link'
  | 'insert_page_break'
  | 'insert_photo'
  | 'line_axis'
  | 'linear_scale'
  | 'margin'
  | 'merge_type'
  | 'mode_comment'
  | 'mode_edit_outline'
  | 'mode'
  | 'monetization_on'
  | 'money_off_csred'
  | 'money_off'
  | 'move_down'
  | 'move_up'
  | 'multiline_chart'
  | 'notes'
  | 'numbers'
  | 'padding'
  | 'pentagon'
  | 'pie_chart_outline'
  | 'pie_chart'
  | 'polyline'
  | 'post_add'
  | 'publish'
  | 'query_stats'
  | 'rectangle'
  | 'scatter_plot'
  | 'schema'
  | 'score'
  | 'short_text'
  | 'show_chart'
  | 'space_bar'
  | 'square'
  | 'stacked_line_chart'
  | 'strikethrough_s'
  | 'subscript'
  | 'superscript'
  | 'table_chart'
  | 'table_rows'
  | 'text_decrease'
  | 'text_fields'
  | 'text_increase'
  | 'title'
  | 'vertical_align_bottom'
  | 'vertical_align_center'
  | 'vertical_align_top'
  | 'vertical_distribute'
  | 'wrap_text'
;

